/**
 * Point d'entrée du chatbot sur le layout
 *
 * Rôle : Affiche le chatbot amélioré (EnhancedChatbot) sur toutes les pages.
 * Technologies : React, EnhancedChatbot
 */
"use client";

import EnhancedChatbot from "./EnhancedChatbot";

export default function Chatbot() {
  // Utilise le chatbot amélioré
  return <EnhancedChatbot />;
}
